<div class="option-text">{{ChartOfAccount.Name}} / {{ChartOfAccount.Number}}</div>

<div class="edit-button">
    <button app-round-button matTooltip="Bearbeiten" matTooltipPosition="left" (click)="$event.stopPropagation(); onEditClick(ChartOfAccount) ">
        <fa-icon icon="pencil-alt"></fa-icon>
    </button>
</div>
